import React, { JSX } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Header from './Header';
import Sidebar from './Sidebar';

interface IProps {
  children: JSX.Element;
}

const Layout = ({ children }: IProps) => {
  return (
    <Row className="mt-3">
      <Col md={3}>
        <Sidebar />
      </Col>

      <Col md={9}>
        <div className="container py-2 position-relative">
          <Header />
          <Card>
            <Card.Body>{children}</Card.Body>
          </Card>
        </div>
      </Col>
    </Row>
  );
};

export default Layout;
